module.exports = __webpack_public_path__ + "assets/images/project/constituencies/radin-mas-smc.jpg?v=0a0035a6";